import { render, staticRenderFns } from "./readReceiptsDialog.vue?vue&type=template&id=6c79480f"
import script from "./readReceiptsDialog.vue?vue&type=script&lang=js"
export * from "./readReceiptsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports